handleCheckoutOrderResponse